import { useTranslation } from 'react-i18next';
import { type SavedSearchSummary } from '$lib/lib/savedSearches';
import { formatKr, formatRooms, formatSqm, formatYear } from '$lib/lib/formatters';

function range(label: string, value?: [number?, number?], fmt: (n: number) => string = (n) => String(n)): string {
  if (!value) return '';
  const [a, b] = value;
  if (a == null && b == null) return '';
  return `${label} ${a != null ? fmt(a) : '–'}–${b != null ? fmt(b) : '–'}`;
}

// Compact human-readable summary for a saved search row.
export function SavedSearchSummaryLine({ summary }: { summary: SavedSearchSummary }) {
  const { t } = useTranslation();
  if (summary.filterCount === 0) {
    return <span className="text-fg-subtle">{t('savedSearches.noFilters')}</span>;
  }
  const parts: string[] = [];
  if (summary.q) parts.push(`"${summary.q}"`);
  if (summary.postnummerCount) parts.push(t('savedSearches.summaryPostnumre', { count: summary.postnummerCount }));
  parts.push(range('m²', summary.m2Range, formatSqm));
  parts.push(range(t('savedSearches.summaryRooms'), summary.roomsRange, formatRooms));
  parts.push(range(t('filters.year').toLowerCase(), summary.yearRange, formatYear));
  parts.push(range(t('savedSearches.summaryRent'), summary.priceRange, formatKr));
  if (summary.statusCount) parts.push(t('savedSearches.summaryStatusCount', { count: summary.statusCount }));
  if (summary.sourceCount) parts.push(t('savedSearches.summarySourceCount', { count: summary.sourceCount }));
  if (summary.sort) parts.push(`${t('savedSearches.summarySort')} ${summary.sort}${summary.dir === 'desc' ? ' ↓' : ' ↑'}`);
  return <span className="text-fg-muted">{parts.filter(Boolean).join(' · ')}</span>;
}
